import * as Scrivito from "scrivito";
import PlaceholderOrYoutubeComponent from "../../Components/PlaceholderOrYoutube";

function YouTubeWidgetComponent(props) {
  const { isOpen, nested } = props;
  return (
    <div>
      {nested && !isOpen ? null : (
        <PlaceholderOrYoutubeComponent
          title={props.widget.get("title")}
          videoUrl={props.widget.get("videoUrl")}
        />
      )}
    </div>
  );
}

Scrivito.provideComponent("YouTubeWidget", YouTubeWidgetComponent);
